import { createWebHistory, createRouter } from "vue-router";
import paymentsRouters from "@/router/payments";
import routes from './routes';
import appConfig from "../../app.config";
import account from "@/router/account";
import procuringEntities from "@/router/procuring-entities";
import userManagement from "@/router/user-management";
import securityRoutes from "@/router/securityRoutes";
import investigationsRoutes from "@/router/investigationRoutes";
import registrationRoutes from "@/router/registrationRoutes";
import biddingRoutes from "@/router/biddingRoutes";
import appealsRoutes from "@/router/appealsRoutes";
import reverseAuctionRouter from "@/router/reverseAuctionRouter";
import eLearningRoutes from "@/router/eLearningRoutes";
import { analyticsRoutes, ANALYTICS_MODULES as M } from '@/analytics/routeAnalytics';
import { checkUserHasRequiredPrivilege } from '@/helpers/utils';

const landingRedirect = {
    path: '/',
    redirect: '/tenders'
};



const allRoutes = [
  ...analyticsRoutes(null, [landingRedirect]),
  ...analyticsRoutes(null, routes),
  ...analyticsRoutes(M.ACCOUNT_MANAGEMENT, account),
  ...analyticsRoutes(M.ADMINISTRATION, procuringEntities),
  ...analyticsRoutes(M.USER_MANAGEMENT, userManagement),
  ...analyticsRoutes(M.PAYMENTS, paymentsRouters),
  ...analyticsRoutes(M.SECURITY, securityRoutes),
  ...analyticsRoutes(M.INVESTIGATIONS, investigationsRoutes),
  ...analyticsRoutes(M.REGISTRATION, registrationRoutes),
  ...analyticsRoutes(M.BIDDING, biddingRoutes),
  ...analyticsRoutes(M.APPEALS, appealsRoutes),
  ...analyticsRoutes(M.REVERSE_AUCTION, reverseAuctionRouter),
  ...analyticsRoutes(M.E_LEARNING, eLearningRoutes),
];

const router = createRouter({
  history: createWebHistory(),
  routes: allRoutes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, left: 0 };
    }
  },
});

router.beforeEach(async (routeTo, routeFrom, next) => {
    const authRequired = routeTo.matched.some((route) => route.meta.authRequired);
    const jwt = sessionStorage.getItem('jwt')
    if (authRequired && (!jwt || !jwt.length)) {
        return next('/login');
    }
    else {
        const privilegesRequired = routeTo.matched.reduce((privileges, route) => {
            if (route.meta.privileges) {
                privileges.push(...route.meta.privileges);
            }
            return privileges;
        }, []);
        if (privilegesRequired.length) {
            if (!checkUserHasRequiredPrivilege(privilegesRequired)) {
                return next({name: 'default', query: {accessDenied: 'true'}});
            }
            return next();
        }
        else {
            next();
        }
    }
});

router.beforeResolve(async (routeTo, routeFrom, next) => {
    try {
        for (const route of routeTo.matched) {
            await new Promise((resolve, reject) => {
                if (route.meta && route.meta.beforeResolve) {
                    route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
                        if (args.length) {
                            next(...args);
                            reject(new Error('Redirected'));
                        } else {
                            resolve();
                        }
                    });
                } else {
                    resolve();
                }
            });
        }
    } catch (error) {
        return;
    }
    document.title = routeTo.meta.title + ' | ' + appConfig.title;
    next();
});

export default router;
